import { Variants } from "framer-motion"

export const motionDurations = {
  fast: 0.18,
  normal: 0.3,
  slow: 0.5,
} as const

export const motionEase = [0.22, 1, 0.36, 1] as const

export const fadeIn: Variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
}

export const fadeInUp: Variants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 20 },
}

export const fadeInDown: Variants = {
  initial: { opacity: 0, y: -20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
}

export const slideInLeft: Variants = {
  initial: { opacity: 0, x: -50 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -50 },
}

export const slideInRight: Variants = {
  initial: { opacity: 0, x: 50 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: 50 },
}

export const scaleIn: Variants = {
  initial: { opacity: 0, scale: 0.95 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.95 },
}

export const staggerContainer: Variants = {
  animate: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2,
    },
  },
}

export const staggerContainerFast: Variants = {
  animate: {
    transition: {
      staggerChildren: 0.05,
      delayChildren: 0.1,
    },
  },
}

export const hoverScale = {
  whileHover: { scale: 1.02 },
  whileTap: { scale: 0.98 },
  transition: { type: "spring", stiffness: 400, damping: 17 },
}

export const hoverLift = {
  whileHover: { y: -4, boxShadow: "0 10px 40px -10px rgba(0,0,0,0.15)" },
  transition: { type: "spring", stiffness: 400, damping: 17 },
}

// ===== NEW PREMIUM ANIMATIONS =====

// Text reveal - character by character
export const textReveal: Variants = {
  initial: { 
    opacity: 0,
    y: 20,
  },
  animate: { 
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1],
    },
  },
}

// Word by word reveal
export const wordReveal: Variants = {
  initial: { opacity: 0, y: 8 },
  animate: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.4, ease: motionEase }
  },
}

// Stagger with word-level animation
export const staggerWords: Variants = {
  animate: {
    transition: {
      staggerChildren: 0.05,
      delayChildren: 0.1,
    },
  },
}

// Glow pulse for CTAs
export const glowPulse: Variants = {
  initial: { boxShadow: "0 0 0 0 rgba(159, 58, 42, 0)" },
  animate: { 
    boxShadow: "0 0 20px 4px rgba(159, 58, 42, 0.3)",
    transition: {
      duration: 1.5,
      repeat: Infinity,
      repeatType: "reverse",
    }
  },
}

// Floating animation for decorative elements
export const float: Variants = {
  initial: { y: 0 },
  animate: { 
    y: -10,
    transition: {
      duration: 2,
      repeat: Infinity,
      repeatType: "reverse",
      ease: "easeInOut",
    }
  },
}

// 3D tilt card effect variants
export const card3DTilt = (rotateX: number = 0, rotateY: number = 0): Variants => ({
  initial: { 
    opacity: 0, 
    rotateX: 0, 
    rotateY: 0,
    scale: 0.95 
  },
  animate: { 
    opacity: 1, 
    rotateX, 
    rotateY,
    scale: 1,
    transition: { duration: 0.4, ease: motionEase }
  },
})

// Number counter animation
export const countUp: Variants = {
  initial: { opacity: 0, scale: 0.5 },
  animate: { 
    opacity: 1, 
    scale: 1,
    transition: { duration: 0.4, ease: motionEase }
  },
}

// Shine sweep effect for cards
export const shineSweep: Variants = {
  initial: { backgroundPosition: "200% center" },
  animate: { 
    backgroundPosition: "-200% center",
    transition: {
      duration: 1.5,
      repeat: Infinity,
      repeatDelay: 3,
    }
  },
}

// Magnetic button pull effect
export const magneticPull = (x: number, y: number): Variants => ({
  whileHover: { 
    x,
    y,
    transition: { type: "spring", stiffness: 300, damping: 15 }
  },
  whileTap: { scale: 0.95 },
})

// Ambient glow pulse
export const ambientGlow: Variants = {
  initial: { opacity: 0.3 },
  animate: { 
    opacity: 0.6,
    transition: {
      duration: 3,
      repeat: Infinity,
      repeatType: "reverse",
      ease: "easeInOut",
    }
  },
}
